import { render, staticRenderFns } from "./customerprops.vue?vue&type=template&id=090f1b3e&"
import script from "./customerprops.vue?vue&type=script&lang=js&"
export * from "./customerprops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plenty24/3672/203/Bigtex5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('090f1b3e')) {
      api.createRecord('090f1b3e', component.options)
    } else {
      api.reload('090f1b3e', component.options)
    }
    module.hot.accept("./customerprops.vue?vue&type=template&id=090f1b3e&", function () {
      api.rerender('090f1b3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/bigtex/customerprops.vue"
export default component.exports